import Vue from 'vue'

Vue.directive('watermark', {
  bind: function (el, binding) {
    console.log('bind:', binding.value);
  },
  inserted: function (el, binding) {
    console.log('insert:', binding.value);
  },
  update(el, binding, vnode, oldVnode) {
    // console.log('update:', binding.value);
    // console.log('update:', vnode);
    // console.log('update:', oldVnode);

    function addWaterMarker(str, parentNode, font, textColor) {

      let id = 'acewill-water-mark';

      let lastWaterMarker = document.getElementById(id);
      if (lastWaterMarker) {
        lastWaterMarker.remove();
      }
      let can = document.createElement('canvas')

      can.width = 420;
      can.height = 160;
      can.style.display = 'none';
      let cans = can.getContext('2d');
      cans.rotate(-15 * Math.PI / 180);
      cans.font = font || '18px Microsoft JhengHei';
      cans.fillStyle = 'rgba(200, 200, 200, 0.70)';
      cans.textAlign = 'left';
      cans.textBaseline = 'Middle';
      cans.fillText(str, can.width / 8, can.height / 2)
      // parentNode.style.backgroundImage = 'url(' + can.toDataURL('image/png') + ')'
      // parentNode.appendChild(can);
      //
      let div = document.createElement('div');
      div.id = id;
      div.style.pointerEvents = 'none';
      div.style.top = '5vh';
      div.style.bottom = '5vh';
      div.style.left = '10%';
      div.style.right = '10%';
      div.style.position = 'fixed';
      div.style.zIndex = '100000';
      // div.style.width = '85%';
      // div.style.height = 370+ 'px';
      div.style.height = document.documentElement.clientHeight + 'px';
      // console.log('------------' + parentNode.offsetHeight);
      // console.log('--------1111----' + parentNode.clientHeight);
      // console.log('--------5555----' + parentNode.scrollHeight);

      div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
      parentNode.appendChild(div);
      // console.log('--------2222----' + div.clientHeight);
    }

    addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor)
  }
});
